import createBaseRenderer from "./createBaseRenderer";
import { useServerMessage } from "b2b/i18n";

export default function createBaseRendererServerMessages({ ...attrs }) {
  return createBaseRenderer({
    useMessage: useServerMessage,
    ...attrs
  });
}
